export default "__VITE_ASSET__9e_R6eys__"